/*
commonview/view_textkeys

Sunny: Textkeys may be stored in an attribute for a hidden tag and then
filtered out by selecting the tag in the dom.
 An exemple exists in src/main/app/packages/mobile-core-assets/templates/html/account/textkeys-payment.mustache.
To filter out the textkeys from an element into an object there is a method in the
core-library, see example in
src/main/app/packages/mobile-core/src/payment/pendingwithdrawals/lib/view.js :
textkeysObj = core.getTextkeysFromElement(elements.textkeys[0], 'pendingwithdrawals:view');

usage:
import viewTextkeys from '../../commonview/view-textkeys.js'
const textkeysObj = viewTextkeys.depositflow(); // add hidden dom-element with textkeys for the area of interest.

*/
import core from '../../common/lib/core.js';

let elements = null;
let textkeysObjDepositflow = null;
const selectors = {
	payment: '#js-textkeys-depositflow'
};

function init() {
	elements = (elements || core.selectElements(selectors, 'view_textkeys:init'));
}

export default {
	depositflow() {
		init();
		textkeysObjDepositflow = (textkeysObjDepositflow || core.getTextkeysFromElement(elements.payment, 'view_textkeys:20:selectElements'));
		return textkeysObjDepositflow;
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/commonview/lib/view-textkeys.js